module.exports = __webpack_public_path__ + "~@/assets/img/2_progress.24cc8262.png";